import { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { Register } from "./Register";
import useOnClickOutside from "_hooks/useOnClickOutside";
import "./login_reg.css";

import { authActions } from "_store";

export { Login };

function Login() {
  const dispatch = useDispatch();
  const loginError = useSelector((x) => x.alert.value);
  const [registerModal, setRegisterModal] = useState(false);
  const currentYear = new Date().getFullYear();
  // form validation rules
  const validationSchema = Yup.object().shape({
    username: Yup.string().required("Username is required"),
    password: Yup.string().required("Password is required"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };

  // get functions to build form with useForm() hook
  const { register, handleSubmit, formState } = useForm(formOptions);
  const { errors, isSubmitting } = formState;
  function onSubmit({ username, password }) {
    return dispatch(authActions.login({ username, password }));
  }

  const openRegister = () => setRegisterModal(!registerModal);
  const registerRefModal = useRef(null);
  useOnClickOutside(registerRefModal, () => setRegisterModal(false));
  return (
    <section className="login-sec d-flex align-center justify-center relative">
      <div className="login-body relative">
        <div className="l-logo relative">
          <img src="/images/login-logo.svg" alt="" />
        </div>
        <div className="login-box relative d-flex flex-col justify-between">
          <form onSubmit={handleSubmit(onSubmit)} className="relative">
            <div className="form-group relative d-flex flex-col-reverse">
              <input
                name="username"
                type="text"
                {...register("username")}
                className={`form-control ${
                  errors.username ? "is-invalid" : ""
                }`}
              />
              <label className="relative d-flex justify-between align-center">
                Username
              </label>
            </div>
            <span className="error">{errors?.username?.message}</span>
            <div className="form-group relative d-flex flex-col-reverse">
              <input
                name="password"
                type="password"
                {...register("password")}
                className={`form-control mb-3 ${
                  errors.password ? "is-invalid" : ""
                }`}
              />
              <label className="relative d-flex justify-between align-center">
                {" "}
                Password{" "}
                <Link to="/account/forgot-password">Forgot Password ?</Link>
              </label>
            </div>
            <span className="error">{errors?.password?.message}</span>
            <div className="error ">{loginError?.message}</div>
            <div className="form-btn-part relative d-flex flex-col">
              <button disabled={isSubmitting} className="btns login-form-btn">
                {isSubmitting && (
                  <span className="spinner-border spinner-border-sm me-1"></span>
                )}
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
      <footer
        style={{
          position: "absolute",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          width: "100%",
          textAlign: "center",
          padding: "10px 0",
          fontSize: "14px",
          color: "#333",
        }}
      >
        ©️ {currentYear} Kunishe Software Private Limted. All Rights Reserved.
      </footer>
      {registerModal && <Register registerRefModal={registerRefModal} />}
    </section>
  );
}
